import {
  AuthSessionContainer,
  ImpersonationBlocker,
} from '@highmark-web/highmark-common';
import { Outlet } from 'react-router-dom';
import { PrivateRoutesContainer } from 'components/private-routes-container.component';

export const ProtectedRoutesLayout = () => (
  <AuthSessionContainer>
    <PrivateRoutesContainer>
      <ImpersonationBlocker>
        <Outlet />
      </ImpersonationBlocker>
    </PrivateRoutesContainer>
  </AuthSessionContainer>
);
